import React from 'react';
import UnifiedAuthCard from '../components/UnifiedAuthCard';

const RegisterPage = () => {
    return <UnifiedAuthCard defaultMode="register" />;
};

export default RegisterPage;
